import { PERMISSIONS } from '../../constants';
import { CPFInput, PhoneInput } from '../../components/Inputs';
import Permission from '../../components/Permission';
import getChainId from '../../lib/getChainId';
import { equalsPassword, notBlank, trimCustomerPasswords } from '../../lib/customerPassword';
import React from 'react';
import { Divider, Grid, Typography } from '@mui/material';
import {
    Create,
    SimpleForm,
    TextInput,
    required,
} from 'react-admin';

const SectionTitle = ({ children }) => (
    <Grid size={12}>
        <Typography variant="subtitle2" color="text.secondary" sx={{ fontWeight: 600, textTransform: 'uppercase', letterSpacing: 0.5 }}>
            {children}
        </Typography>
        <Divider sx={{ mt: 1 }} />
    </Grid>
);

export default ({ permissions, ...props }) => {
    return (
        <Permission permission={PERMISSIONS.CREATE_CUSTOMER}>
            <Create {...props} title="Cadastrar novo cliente" transform={trimCustomerPasswords}>
                <SimpleForm defaultValues={{ chainId: getChainId() }} redirect="show">
                    <Grid container spacing={2} alignItems="flex-start" sx={{ width: '100%', maxWidth: 900 }}>
                        <SectionTitle>Dados pessoais</SectionTitle>

                        <Grid size={{ xs: 12, md: 6 }}>
                            <TextInput
                                source="name"
                                label="Nome"
                                InputProps={{ autoComplete: 'off' }}
                                validate={required()}
                                fullWidth
                            />
                        </Grid>
                        <Grid size={{ xs: 12, sm: 6, md: 3 }}>
                            <CPFInput
                                source="cpf"
                                label="CPF"
                                InputProps={{ autoComplete: 'off' }}
                                isRequired
                                fullWidth
                            />
                        </Grid>
                        <Grid size={{ xs: 12, sm: 6, md: 3 }}>
                            <PhoneInput
                                source="cellphone"
                                label="Celular"
                                InputProps={{ autoComplete: 'off' }}
                                isRequired
                                fullWidth
                            />
                        </Grid>

                        <SectionTitle>Acesso</SectionTitle>

                        <Grid size={{ xs: 12, sm: 6, md: 3 }}>
                            <TextInput
                                source="password"
                                label="Senha"
                                InputProps={{ autoComplete: 'new-password' }}
                                validate={[required(), notBlank]}
                                fullWidth
                            />
                        </Grid>
                        <Grid size={{ xs: 12, sm: 6, md: 3 }}>
                            <TextInput
                                source="confirmPassword"
                                label="Confirmar Senha"
                                InputProps={{ autoComplete: 'new-password' }}
                                validate={[required(), equalsPassword]}
                                fullWidth
                            />
                        </Grid>
                    </Grid>
                </SimpleForm>
            </Create>
        </Permission>
    )
};
